import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SelectModule } from 'ng-select';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import {Select2ApiComponent} from './select2Api.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,

  ],
  exports: [
    Select2ApiComponent
  ],
  declarations: [Select2ApiComponent]
})
export class Select2ApiModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/select2Api/select2Api.module.ts